import React from 'react';
import { Box, Button, ButtonMode, Link, Separator, Text } from 'edenred-ui';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

export function CustomerCareRedirect() {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <>
      <Separator text={t('login_otp.separator')} />
      <Box textAlign="center">
        <Text small color={theme.gray50}>
          {t('login_otp.support_text')}
        </Text>
        <Box display="flex" flexDirection="column" alignContent="center" py={2}>
          <Button id="customer_care_redirect" mode={ButtonMode.Link}>
            <Link href={t('login_otp.support_link_url')} target="_blank">
              {t('login_otp.support_link_text')}
            </Link>
          </Button>
        </Box>
      </Box>
    </>
  );
}
